<template lang="pug">
.footer_quickmenu_mobile.d-m-none.container-fluid.i_ptb_4
  .container.d-flex.justify-content-around
    router-link.icon_btn(
      v-for="(link, index) in links",
      tag="a",
      :to="link.to || { name: link.linkName }",
      :key="index"
    )
      img(:src="link.icon")
      p {{ link.name }}
</template>

<script>
import CustomerImg from "@/assets/img/icon/q_customer.png";
import QAImg from "@/assets/img/icon/q_qa.png";
import LocationImg from "@/assets/img/icon/q_location.png";
import ContactImg from "@/assets/img/icon/q_contact.png";
import DownloadImg from "@/assets/img/icon/q_download.png";
export default {
  name: "QuickMenuMobile",
  data() {
    return {
      links: [
        {
          name: "客戶關懷",
          to: { name: "Customize", params: { page: "customercare" } },
          icon: CustomerImg,
        },
        {
          name: "聯絡我們",
          linkName: "CustomerServiceContactUs",
          icon: ContactImg,
        },
        { name: "常見問題", linkName: "CustomerServiceFAQ", icon: QAImg },
        {
          name: "下載文件",
          linkName: "CustomerServiceDocumentDownload",
          icon: DownloadImg,
        },
        { name: "服務據點", linkName: "Location", icon: LocationImg },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.footer_quickmenu_mobile {
  position: fixed;
  bottom: 0;
  background-color: #f0f0f0;
  z-index: 8;

  .icon_btn {
    text-align: center;

    img {
      @include circle(47px, 47px);
    }

    p {
      color: $color_blue_btn_ci;
      font-size: 13.4px;
      margin-bottom: 0;
    }
    &:first-child {
      img {
        border-radius: 0px;
      }
    }
  }
}

@media (max-width: 575px) {
  .footer_quickmenu_mobile {
    padding-top: 2.48vw;
    padding-bottom: 2.48vw;

    .icon_btn {
      cursor: pointer;

      img {
        @include circle(8vw, 8vw);
      }

      p {
        font-size: 2.48vw;
        margin-bottom: 0;
      }
    }
  }
}
</style>
